import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #f7f8f9;
  display: flex;
  color: #1e2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
`;
export const CardDiv = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: 0px 36px auto 36px;
`;
export const LevelWrapDiv = styled.div`
  display: flex;
  margin: 30px 30px 30px 0px;
  position: relative;
`;
export const LevelNumDiv = styled.div`
  color: #1e2228;
  background-color: #ececec;
  height: 30px;
  width: 30px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
`;
export const LevelLoaderWrapDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1ec05b;
  background-color: #bcecd7;
  height: 24px;
  width: 24px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  font-weight: bold;
  border: 4px solid #ffffff;
`;
export const LevelLoaderDiv = styled.div`
  border: 2px solid #1ec05b;
  border-radius: 50%;
  border-top: 2px solid transparent;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  position: absolute;

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const LevelDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  font-size: 14px;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
`;
export const LevelBarDiv = styled.div`
  height: 1px;
  width: 480px;
  position: absolute;
  z-index: 0;
  top: 15px;
  left: 80px;
  background-image: linear-gradient(
    to right,
    #c8c9cc 70%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 10px 2px;
  background-repeat: repeat-x;
`;
export const LevelActiveBarDiv = styled.div`
  height: 2px;
  width: 134px;
  position: absolute;
  z-index: 1;
  top: 13px;
  left: 80px;
  border-bottom: 1px solid #1ec05b;
  transition: all 1s;
`;

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-right: 10px;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked ~ span {
      background-color: #21c17a;
    }
    &:checked ~ span:before {
      -webkit-transform: translateX(15px);
      -ms-transform: translateX(15px);
      transform: translateX(15px);
    }
    &:focus ~ span {
      box-shadow: 0 0 1px #21c17a;
    }
  }
  & span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #c4c6cb;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    border-radius: 34px;
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 4px;
      bottom: 3px;
      background-color: white;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      border-radius: 50%;
    }
  }
`;
export const TestWrapDiv = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  padding: 30px;
  border-bottom: 1px solid #ececec;
`;
export const TestImage = styled.img`
  height: 132px;
  width: 274px;
  flex-shrink: 0;
  background-color: #ebebeb;
  border-radius: 6px;
`;
export const TestColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TestActionWrapDiv = styled.div`
  display: flex;
  margin: 14px 0px auto 0px;
`;
export const ActionButton = styled.button`
  margin-left: 8px;
  padding: 6px;
  border-radius: 4px;
  background-color: #ffffff;
  &:hover {
    background-color: #f7f8f9;
  }
  & img {
    height: 20px;
    width: 20px;
  }
`;
export const TestSwitchDiv = styled.div`
  display: flex;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  margin: 0px 30px;
`;
export const TestInfoWrapDiv = styled.div`
  display: flex;
  align-items: center;
  color: #939599;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin: 20px 0px;
  & div {
    display: flex;
    align-items: center;
    margin-right: 25px;
  }
  & img {
    width: 13px;
    height: 13px;
    margin-right: 7px;
  }
`;
export const TestHeadingP = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  margin: 0px;
`;
export const TestUpdateDiv = styled.div`
  color: #939599;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
`;
export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
  & input {
    width: 600px;
    height: 55px;
    border: 1px solid ${(props) => (props.error ? "#E74C3C" : "#c9c9c9")};
    &:focus {
      border: 1px solid #1b49ea;
    }
  }
  & select {
    width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1b49ea;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid ${(props) => (props.error ? "#E74C3C" : "#c9c9c9")};
    padding: 13px 15px;
    font-family: sans-serif;
    line-height: 18px;
    &:focus {
      border: 1px solid #1b49ea;
    }
  }
`;
export const AvailableDiv = styled.div`
  width: 280px;
  height: 50px;
  background: #ffffff;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  margin: 0px;
  padding: 13px 15px;
  box-sizing: border-box;
  border: 1px solid ${(props) => (props.error ? "#E74C3C" : "#c9c9c9")};
`;
export const InputTitleDiv = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`;
export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #e74c3c;
  padding-top: 2px;
`;
export const InputNewButton = styled.button`
  height: 55px;
  width: 55px;
  background-color: #ffffff;
  border: 1px solid #1b49ea;
  border-radius: 8px;
  color: #1b49ea;
  font-size: 26px;
  margin-left: 14px;
  &:hover {
    color: #ffffff;
    background-color: #1b49ea;
  }
`;
export const DetailsWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 57px;
`;
export const SaveWrapDiv = styled.div`
  border-top: 1px solid #ececec;
  padding: 30px 30px 45px 30px;
  display: flex;
  align-items: center;
  margin-top: 40px;
`;
export const SaveButton = styled.button`
  width: 161px;
  height: 56px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #1b49ea;
`;
export const BackButton = styled.button`
  width: 161px;
  height: 56px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1b49ea;
  background-color: #edf0fe;
  margin-right: 26px;
`;
export const CancelLink = styled(Link)`
  width: 161px;
  height: 56px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1b49ea;
  background-color: #edf0fe;
  margin-right: 26px;
  text-decoration: none;
`;

export const CoverImageWrapDiv = styled.div`
  width: 600px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F6FAFF;
  border: 1px dashed #D9D9D9;
  border-radius: 10px;
  font-size: 12px;
  color: #506D85;
  padding: 20px 0;
    & img {
      width: 16px;
      height: 15px;
      margin-right: 6px;
    }
  }
`;

export const RowDiv = styled.div`
  display: flex;
`;

export const QuestionTable = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
  & th {
    padding: 14px 30px;
    background-color: #edeff1;
  }
  & tr {
    border-bottom: 1px solid #ececec;
  }
  & td {
    padding: 16px 30px;
    & > div {
      display: flex;
      align-items: center;
      & > button {
        height: 32px;
        width: 32px;
        background: none;
        padding: 6px;
        border-radius: 4px;
        &:hover {
          background: #edf0fe;
        }
      }
      & > button:first-child {
        margin-right: 12px;
      }
    }
  }
`;
export const MarksWrapDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 30px 30px 30px;
  & div {
    width: 262px;
    height: 57px;
    background-color: #edf0fd;
    border-radius: 8px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    padding: 0px 16px;
    box-sizing: border-box;
    font-size: 16px;
    & strong {
      margin-left: 4px;
    }
  }
  & button {
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    color: #ffffff;
    display: flex;
    align-items: center;
    background: #1b49ea;
    border-radius: 8px;
    padding: 5px 17px;
    & span {
      height: 15px;
      overflow: hidden;
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
`;
export const QlistWrapDiv = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 2%;
  flex-shrink: 0;
`;
export const QlistDiv = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e6e4e4;
  padding: 20px;
  box-sizing: border-box;
`;
export const QlistQuestionDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 4px;
  & div:first-child {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 11px;
  }
  & div:last-child {
    font-size: 12px;
    line-height: 15px;
    color: #1b49ea;
    cursor: pointer;
  }
`;
export const QlistEditButton = styled.button`
  height: 32px;
  width: 32px;
  padding: 8px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-left: auto;
  & img {
    height: 16px;
    width: 20px;
  }
  &:hover {
    background-color: #f0f0f0;
  }
`;
export const SearchDiv = styled.div`
  position: relative;
  & img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  & input {
    height: 38px;
    width: 200px;
    margin: 0px;
    padding: 0px 12px 0px 40px;
  }
`;
export const FilterWrapDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border: 1px solid #e6e4e4;
  & > div {
    margin: 0px 10px 0px 0px;
    &:last-child {
      margin: 0px;
    }
  }
`;
export const QeditRowDiv = styled.div`
  display: flex;
  border: 1px solid #e6e4e4;
  padding: 12px;
`;
export const QeditWrapDiv = styled.div`
  flex-grow: 1;
  & textarea {
    width: 100%;
    border: 1px solid #c9c9c9;
    padding: 9px 15px;
    font-family: sans-serif;
    font-size: 14px;
    line-height: 22px;
    &:focus {
      border: 1px solid #1b49ea;
    }
  }
`;
export const QeditTextDiv = styled.div`
  min-height: 64px;
  width: 100%;
  border: 1px solid #c9c9c9;
  padding: 9px 15px;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 22px;
  box-sizing: border-box;
  border-radius: 6px;
`;
export const QeditActionDiv = styled.div`
  display: flex;
  margin-top: 12px;
  & button {
    height: 43px;
    width: 78px;
    font-size: 12px;
    font-weight: 600;
    color: #1b49ea;
    background-color: #edf0fd;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 17px;
    margin-right: 10px;
    &:last-child {
      color: #ffffff;
      background-color: #1b49ea;
    }
  }
`;
export const QeditMarkDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  & div {
    font-size: 14px;
    margin-bottom: 10px;
  }
  & input {
    width: 55px;
    height: 38px;
    border: 1px solid #c9c9c9;
  }
`;
export const TopBorderBoxDiv = styled.div`
  border-top: 10px solid #ececec;
  padding: 30px;
  display: flex;
  flex-direction: column;
`;
export const TopBorderHeadDiv = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 35px;
`;
export const WrapCheckboxDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  & label {
    position: relative;
    display: inline-block;
    width: 48%;
    margin: 15px 0px;
    padding-left: 24px;
    line-height: 23px;
    box-sizing: border-box;
    & input {
      opacity: 0;
      width: 0;
      height: 0;
      &:checked ~ span {
        border: 1px solid #1b49ea;
      }
      &:checked ~ span:before {
        background-color: #1b49ea;
      }
      &:focus ~ span {
        box-shadow: 0 0 1px #21c17a;
      }
    }
    & span {
      height: 16px;
      width: 16px;
      position: absolute;
      cursor: pointer;
      top: 2px;
      left: 0;
      background-color: #ffffff;
      border: 1px solid #969696;
      -webkit-transition: 0.1s;
      transition: 0.1s;
      border-radius: 16px;
      &:before {
        position: absolute;
        content: "";
        height: 10px;
        width: 10px;
        left: 2px;
        bottom: 2px;
        background-color: #ffffff;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        border-radius: 50%;
      }
    }
  }
`;
export const ModalSaveWrap = styled.div`
  border-top: 1px solid #ececec;
  padding: 20px 30px;
  display: flex;
  margin-top: 15px;
`;
export const ModalCheckWrapDiv = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  align-items: center;
  margin: 0px 30px;
  position: relative;
  height: 24px;
  cursor: pointer;
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid ${(props) => (props.active ? "#1B49EA" : "#C4C6CB")};
    border-radius: 4px;
    margin-right: 8px;
  }
  &:after {
    position: absolute;
    display: ${(props) => (props.active ? "block" : "none")};
    content: "";
    height: 10px;
    width: 5px;
    left: 8px;
    top: 4px;
    border-right: 2px solid #1b49ea;
    border-bottom: 2px solid #1b49ea;
    transform: rotate(45deg);
  }
`;
export const PleaseAddPoolDiv = styled.div`
  padding: 60px 30px;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #bfbfbf;
  border-top: 1px solid #ececec;
`;
export const AddButton = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:before {
    content: "";
    width: 12px;
    height: 1px;
    position: absolute;
    background-color: #1e2228;
  }
  &:after {
    content: "";
    height: 12px;
    width: 1px;
    position: absolute;
    background-color: #1e2228;
  }
`;
export const MinusButton = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:before {
    content: "";
    width: 12px;
    height: 1px;
    position: absolute;
    background-color: #1e2228;
  }
`;
export const ManualMarksDiv = styled.div`
  font-size: 12px;
  text-align: center;
  padding: 4px;
  border-radius: 2px;
  margin: 4px 0px;
  background-color: #edf0fd;
`;
export const SaveErrorDiv = styled.div`
  font-size: 14px;
  color: #e74c3c;
  padding-top: 2px;
  margin-left: 12px;
`;

export const CoverImageLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  background: #1b49ea;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: "Arial";
  cursor: pointer;
`;

export const CoverImageInput = styled.input`
  display: none;
`;
